import React from 'react';
import { Link } from 'react-router';
import Button from 'componentsV2/Button';
import { helperGetHomeUrl } from 'helpers/RouteHelper';

import Style from './NotFound.module.scss';

const NotFound = () => {
  const {
    watchlistPage_emptyTitle: watchlistEmptyTitle,
    watchlistPage_emptySubtitle: watchlistEmptySubtitle,
    watchlistPage_emptyButton: watchlistEmptyButton,
  } = window.Language;

  return (
    <div className={Style.notFoundContainer} aria-live="polite">
      <h3 className={Style.notFoundTitle}>{watchlistEmptyTitle}</h3>
      <p className={Style.notFoundSubTitle}>{watchlistEmptySubtitle}</p>
      <Link to={window?.ExternalConfig?.watchlistEmptyBrowseRoute ?? helperGetHomeUrl()}>
        <Button label={watchlistEmptyButton} onClick={() => {}} theme={Style} />
      </Link>
    </div>
  );
};

export default NotFound;
